import type { LayoutBlock } from '@web-studio/shared-schemas';
import {
  sushiFooter,
  sushiHeroEditorial,
  sushiMenuGrid,
  sushiNavigationHeader,
} from '../blocks/sushiBar';

/** Restaurant / minimum — Hinoki Counter sushi seed (Essential Presence blocks). */
export const sushiBarMinimumPage: LayoutBlock[] = [
  sushiNavigationHeader,
  sushiHeroEditorial,
  sushiMenuGrid,
  sushiFooter,
];
